import React from 'react'

export default function Index () {
  return (
    <div>
      Index
    </div>
  )
}
